import book from "../img/svg/book.svg";

/**
 * Creates a list item to be used in a nav section
 *
 * @param {object} details {link, text, target, classes}
 * @returns an HTML 'li' element
 */
export function makeNavLink(details) {
  let navLink = document.createElement("li");
  navLink.classList.add("nav-link");

  if (details.classes !== undefined) {
    navLink.classList.add(details.classes);
  }

  navLink.innerHTML = `
    <div>
        <a href="${details.link}" target="${details.target}">
            ${details.text}
        </a>
    </div>`;

  return navLink;
}

export function addTagline(tagline) {
  let header = document.querySelector("#header-left");

  let taglineContainer = document.createElement("div");
  taglineContainer.id = "tagline";
  taglineContainer.innerHTML = tagline;

  header.appendChild(taglineContainer);
}

export default function injectNavBar() {
  /* ============================ */
  /* create header navigation bar */
  /* ============================ */

  let header = document.querySelector("#header-right");
  let logoLink = document.querySelector(".header-logo-link").href;

  let headerNavBar = document.createElement("div");
  headerNavBar.id = "custom-nav-bar";
  let headerNavList = document.createElement("ul");

  let headerNavLinks = [
    {
      link: logoLink,
      text: "Home",
      target: "",
      classes: "home-nav",
    },
    {
      link: logoLink + "page/course-catalog",
      text: "All Courses",
      target: "",
      classes: "all-nav",
    },
    {
      link: logoLink + "page/webinars",
      text: "Webinars",
      target: "",
      classes: "ct-nav",
    },
    {
      link: logoLink + "page/live-training",
      text: "Live Training",
      target: "",
      classes: "lt-nav",
    },
  ];

  for (let link of headerNavLinks) {
    headerNavList.append(makeNavLink(link));
  }

  let help = document.createElement("li");
  help.id = "help-nav";
  help.innerHTML = '<div class="nav-link-help">Need Help?</div>';

  let helpPopup = document.createElement("div");
  helpPopup.id = "help-nav-popup";
  helpPopup.innerHTML = `
        <div class="help-articles">
            <a href="https://help.clickup.com/hc/en-us" target="_blank"><img src="${book}"> Help Articles</a>
        </div>
        <div class="help-help">
            Need help with your ClickUp Workspace? Contact us:
            <a class="btn" href="https://help.clickup.com/hc/en-us/requests/new" target="_blank">
                Help Center Request
            </a>
        </div>
        <div class="help-training">
            Questions regarding ClickUp University? Email us at:
            <a class="btn" href="mailto:training@clickup.com?subject=ClickUp University: Question or Issue" target="_blank">
                training@clickup.com
            </a>
        </div>
        <div class="help-survey">
            <a class="btn" href="https://clickup.qualtrics.com/jfe/form/SV_5nH2ESKX1nIHEKG" target="_blank">
                Give Feedback
            </a>
        </div>
    `;

  help.appendChild(helpPopup);

  headerNavList.appendChild(help);

  headerNavBar.appendChild(headerNavList);
  header.prepend(headerNavBar);
}
